// extracted by mini-css-extract-plugin
export default {"noticeSubtext":"src-modules-email-confirmation-style__noticeSubtext_gCNIQ","buttonWrapper":"src-modules-email-confirmation-style__buttonWrapper_uzetC"};